export default __webpack_public_path__ + "static/media/vietchaulogo.bf6dbf42.png";